import React from 'react';
import classNames from 'classnames';
import iCThetanCoin from 'assets/img/thetan_coin_V2.png';
import icThetanGem from 'assets/img/thetan_gem_V2.png';
import styles from './styles.module.scss';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import { MainCurrency } from '../../config';
const coinTypeMap = {
  [MainCurrency.THETAN_COIN]: {
    name: 'Thetan Coin',
    image: iCThetanCoin,
    currency: 'THC'
  },
  [MainCurrency.THETAN_GEM]: {
    name: 'Thetan Gem',
    image: icThetanGem,
    currency: 'THG'
  }
};

const CoinCard = ({
  className,
  coinType,
  amount,
  isWrongNetwork
}) => {
  const coinInfo = coinTypeMap[coinType];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.icon, coinType === MainCurrency.THETAN_COIN ? styles.yellow : styles.green)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: coinInfo.image
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, coinInfo.name)), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.top
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.coin, coinType === MainCurrency.THETAN_COIN ? styles.yellow : styles.green)
  }, !isWrongNetwork && amount ? formatCurrency(amount, {
    trimWholeFraction: true,
    withCurrency: true
  }) : `-- ${coinInfo.currency}`), /*#__PURE__*/React.createElement("div", {
    className: styles.subCoin
  }, !isWrongNetwork && amount ? formatCurrencyInFiat(amount, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '-- USD')), isWrongNetwork && /*#__PURE__*/React.createElement("div", {
    className: styles.wrongNetwork
  }, /*#__PURE__*/React.createElement("span", null, "Wrong network"))));
};

export default CoinCard;